import { useState } from 'react';
import { Stack, Tab, Tabs } from '@mui/material';
import { PolicyRules } from '../policy-rules';
import { RefundCard } from './refund-card';
import { RefundListSkeleton } from './skeleton';
import banknote from '@/assets/images/svg/banknote.svg';
import { Pagination } from '@/components/shared/pagination';
import { StateMessage } from '@/components/shared/state-message';
import { RefundStatusFilter, useResourceApprovalsIndex } from '@/data/subsidy';

const itemsPerPage = '4';

export const RefundList = () => {
  const [page, setPage] = useState(1);
  const [statusFilter, setStatusFilter] = useState(RefundStatusFilter.All);

  const requestParams = {
    page: page.toString(),
    per_page: itemsPerPage.toString(),
    status: statusFilter,
  };

  const { resourceApprovals, totalPages, isLoading } =
    useResourceApprovalsIndex({
      searchParams: requestParams,
    });
  const handleStatusFilterChange = (
    _: React.SyntheticEvent,
    newValue: RefundStatusFilter
  ) => {
    setStatusFilter(newValue);
  };

  if (isLoading) return <RefundListSkeleton />;

  return (
    <Stack gap={3}>
      <Stack
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        flexWrap="wrap"
        gap={2}
      >
        <PolicyRules />
        <Tabs
          value={statusFilter}
          onChange={handleStatusFilterChange}
          sx={{ width: { xs: '100%', md: 'auto' } }}
        >
          <Tab label="Todos" value={RefundStatusFilter.All} />
          <Tab label="Abertos" value={RefundStatusFilter.InProgress} />
          <Tab label="Finalizados" value={RefundStatusFilter.Finalized} />
        </Tabs>
      </Stack>
      <Stack gap={2}>
        {resourceApprovals?.length === 0 && !isLoading && (
          <StateMessage
            image={banknote}
            imageSize={{ width: 72, height: 55 }}
            title="Você ainda não possui pedidos de reembolso"
            description="Suas solicitações aparecerão aqui"
          />
        )}
        {resourceApprovals?.map((resourceApproval) => (
          <RefundCard
            // Podem haver multiplos pedidos de reembolso para o mesmo recurso
            key={resourceApproval.uuid + resourceApproval?.refund_request?.uuid}
            resourceApproval={resourceApproval}
          />
        ))}
      </Stack>
      {totalPages > 1 && (
        <Stack direction="row" justifyContent="flex-end" my={2}>
          <Pagination
            currentPage={page}
            totalPages={totalPages}
            pageChange={setPage}
          />
        </Stack>
      )}
    </Stack>
  );
};
